export default __webpack_public_path__ + "3b5f34a7b60d750ea013b9adf75e5d22.svg";